// ============================================
// Parent Web - Entry Point
// ============================================

import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { SDKProvider } from '@pc/hooks';
import type { SDKConfig } from '@pc/sdk';
import { App } from './App';
import { ThemeProvider } from './providers/ThemeProvider';
import './styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

const sdkConfig: SDKConfig = {
  baseUrl: import.meta.env.VITE_API_URL ?? '',
  timeout: 30000,
  tokenProvider: async () => sessionStorage.getItem('access_token'),
  onUnauthorized: () => {
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('refresh_token');
    window.location.href = import.meta.env.BASE_URL + 'login';
  },
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <SDKProvider config={sdkConfig} queryClient={queryClient}>
        <BrowserRouter basename={import.meta.env.BASE_URL}>
          <App />
        </BrowserRouter>
      </SDKProvider>
    </ThemeProvider>
  </React.StrictMode>
);
